import createStyled from '../createStyled';
import type { CreateMUIStyled } from '../createStyled';

const styled: CreateMUIStyled = createStyled();

export default styled;
